import script from "./RcCodeMirror.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcCodeMirror.vue?vue&type=script&setup=true&lang=ts"

import "./RcCodeMirror.vue?vue&type=style&index=0&id=9cbd2fcc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cbd2fcc"]])

export default __exports__